import { render, staticRenderFns } from "./Universal.vue?vue&type=template&id=8165f738&scoped=true"
import script from "./Universal.vue?vue&type=script&lang=js"
export * from "./Universal.vue?vue&type=script&lang=js"
import style0 from "./Universal.vue?vue&type=style&index=0&id=8165f738&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8165f738",
  null
  
)

export default component.exports